import { render, staticRenderFns } from "./Unsubscribers.vue?vue&type=template&id=3fae96c0&scoped=true"
import script from "./Unsubscribers.vue?vue&type=script&lang=js"
export * from "./Unsubscribers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fae96c0",
  null
  
)

export default component.exports